export default "__VITE_ASSET__D3yqJE2V__"